/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IObrienRetailersData } from './obrien-retailers.data';
import { IObrienRetailersProps } from './obrien-retailers.props.autogenerated';

export interface IObrienRetailersViewProps extends IObrienRetailersProps<IObrienRetailersData> {

}

/**
 *
 * ObrienTeam component
 * @extends {React.PureComponent<IObrienRetailersProps<IObrienRetailersData>>}
 */
class ObrienRetailers extends React.PureComponent<IObrienRetailersProps<IObrienRetailersData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default ObrienRetailers;
